class ProductInfoScroll extends HTMLElement {
    connectedCallback() {
        this.breakpointQuery = window.matchMedia("(min-width: 768px)")
        this.onBreakpointChange = () =>
            this.breakpointQuery.matches ? this.init() : this.destroy()
        this.breakpointQuery.addEventListener("change", this.onBreakpointChange)
        this.onBreakpointChange()
    }

    disconnectedCallback() {
        this.breakpointQuery?.removeEventListener(
            "change",
            this.onBreakpointChange
        )
        this.destroy()
    }

    init() {
        const page = window.lenis
        if (this.lenis || !window.Lenis || !page?.options) return

        // Mirror the page instance so reduced-motion settings carry over.
        this.lenis = new Lenis({
            wrapper: this,
            content: this.firstElementChild,
            lerp: page.options.lerp,
            smoothWheel: page.options.smoothWheel,
            allowNestedScroll: true,
            autoRaf: true,
            virtualScroll: this.onVirtualScroll,
        })
    }

    destroy() {
        this.lenis?.destroy()
        this.lenis = null
    }

    onVirtualScroll = ({ deltaX, deltaY, event }) => {
        const page = window.lenis
        if (!event.type.includes("wheel") || event.ctrlKey) return
        if (deltaY >= 0 || Math.abs(deltaX) > Math.abs(deltaY)) return
        if (!page || page.isStopped || page.scroll <= 0) return

        event.preventDefault()
        event.lenisStopPropagation = true
        page.scrollTo(page.targetScroll + deltaY, {
            programmatic: false,
            lerp: page.options.lerp,
            duration: page.options.duration,
            easing: page.options.easing,
        })
        return false
    }
}

if (!customElements.get("product-info-scroll")) {
    customElements.define("product-info-scroll", ProductInfoScroll)
}
